// extracted by mini-css-extract-plugin
export default {"spaceToggle":"rootLayout_spaceToggle__+U+q0","unauthorizedUser":"rootLayout_unauthorizedUser__zJEDH"};